import H4 from "../ui/Typography/Headings/H4/styled";
import List from "../ui/List";
import React from "react";
import SchoolCategory from "./SchoolCategory";
import Sidebar from "../ui/Sidebar/styled";
import getSchoolCategoriesSelector from "../../../state/selectors/SchoolSelectors/getSchoolCategoriesSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const SchoolCategories: React.FC = () => {
    const categories = useSelector((state: Store) => getSchoolCategoriesSelector(state));
    return (
        <Sidebar>
            <Title>Categorie</Title>
            <List>
                {categories.map((mainCategory: SchoolCategory) => (
                    <SchoolCategory
                        key={mainCategory.term_id}
                        name={mainCategory.name}
                        term_id={mainCategory.term_id}
                        order={mainCategory.order}
                        isSubLevel={Boolean(mainCategory.parent)}
                    >
                        {mainCategory.subCategories && mainCategory.subCategories.length ? (
                            <List>
                                {mainCategory.subCategories.map((subCategory: SchoolCategory) => (
                                    <SchoolCategory
                                        key={subCategory.term_id}
                                        name={subCategory.name}
                                        term_id={subCategory.term_id}
                                        order={subCategory.order}
                                        isSubLevel={Boolean(subCategory.parent)}
                                    />
                                ))}
                            </List>
                        ) : null}
                    </SchoolCategory>
                ))}
            </List>
        </Sidebar>
    );
};

export default SchoolCategories;

const Title = styled(H4 as any)`
    padding: 1.5rem 1rem 1rem 1rem;
`;
